module.exports = __webpack_public_path__ + "img/15.a35f5580.jpg";